<template>
  <a-card>
    <a-descriptions title="Info Leave / Thông tin loại nghỉ phép" :column="3">
      <!-- <a-descriptions-item label="Số ngày nghỉ tối đa">
        {{ infoTypeWorkLeave.limit }}
      </a-descriptions-item> -->
      <a-descriptions-item label="Benefit / Chế độ" :span="2">
        {{ codeBenefit2Title(infoTypeWorkLeave.benefit) }}
      </a-descriptions-item>
    </a-descriptions>
    <CollapseCard>
      <div slot="content">
        <a-alert
          v-if="infoTypeWorkLeave && infoTypeWorkLeave.id"
          banner
          type="info"
          style="white-space: pre-line; display: block;"
        >
          <div
            slot="message"
            v-if="infoTypeWorkLeave.description"
            v-html="infoTypeWorkLeave.description"
          ></div>
          <div slot="message" v-else>
            Empty
          </div>
        </a-alert>
        <a-alert
          v-else
          message="Vui lòng chọn loại nghỉ phép"
          banner
          type="info"
          style="white-space: pre-line;"
        />
      </div>
    </CollapseCard>
  </a-card>
</template>
<script>
import codeBenefit2Title from "../../services/codeBenefit2Title";
import CollapseCard from "@/components/common/collapseCard";

export default {
  components: { CollapseCard },
  props: {
    infoTypeWorkLeave: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { codeBenefit2Title };
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
